import { IFirmware } from '../IFirmware';
import { CommCard } from './comm-card.model';

export class CommCardWithSmartConnectId implements IFirmware
{
    public CommCard: CommCard;
    public SmartConnectId: string;

    constructor(json: object = null)
    {
        if (json)
        {
            this.CommCard = new CommCard(json['CommCard']);
            this.SmartConnectId = json['SmartConnectId'];
        }
    }

    get FirmwareVersionId(): number
    {
        return this.CommCard.FirmwareVersionId;
    }

    get FirmwareVersion(): number
    {
        return this.CommCard.FirmwareVersion;
    }

    get LatestFirmwareVersion(): number
    {
        return this.CommCard.LatestFirmwareVersion;
    }

    get FirmwareDescription(): string
    {
        return this.CommCard.FirmwareDescription;
    }

    get DeviceTypeId(): number
    {
        return this.CommCard.DeviceTypeId;
    }

    get DeviceId(): number
    {
        return this.CommCard.DeviceId;
    }

    get Id(): number
    {
        return this.CommCard.Id;
    }

    public getName(): string
    {
        return this.SmartConnectId;
    }
}
